import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function () {
    const knowSlider = new Swiper(".know__head", {
        loop: true,
		speed: 600,
        autoHeight: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
		autoplay: {
			delay: 10000,					// Delay of 10 seconds
			disableOnInteraction: false,	// Autoplay will not be disabled after user interactions (swipes)
			pauseOnMouseEnter: true,		// Pause on mouse hover
		},
    });

    if (document.querySelector(".know__head")) {
        const knowHead = document.querySelector(".know__head");
        const slidesCount = knowSlider.slides.length;

        if (slidesCount === 1) {
            knowHead.classList.add("not-swiper");
        }
    }
});
